export enum Role {
    Authority = 'Authority',
    Admin = 'Admin',
    Surveyor = 'Surveyor'
}